











































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
// @ts-ignore
import {Hooper, Slide} from 'hooper';
import 'hooper/dist/hooper.css';

import {CELL_SIZES} from '@/constants/orders';


interface HooperCarousel extends HTMLElement {
  slideTo(n: number): void;
}


const translateSizeToSlide = (size: number): number => {
  switch (size) {
    case CELL_SIZES.SIZE_ID_SMALL:
      return 0;
    case CELL_SIZES.SIZE_ID_MEDIUM:
      return 1;
    case CELL_SIZES.SIZE_ID_LARGE:
      return 2;
  }

  return CELL_SIZES.SIZE_ID_MEDIUM;
};

const translateSlideToSize = (slide: number): CELL_SIZES => {
  switch (slide) {
    case 0:
      return CELL_SIZES.SIZE_ID_SMALL;
    case 1:
      return CELL_SIZES.SIZE_ID_MEDIUM;
    case 2:
      return CELL_SIZES.SIZE_ID_LARGE;
  }

  return CELL_SIZES.SIZE_ID_MEDIUM;
};


@Component({
  name: "CellChooser",
  components: {
    Hooper,
    Slide,
  },
})
export default class CellChooser extends Vue {
  private cellSlideSelected: number = 1;

  @Prop()
  private lastSize!: CELL_SIZES;

  @Ref()
  private carousel!: HooperCarousel;

  private carouselData() {
    this.carousel.slideTo(this.cellSlideSelected);
  }

  private mounted() {
    this.cellSlideSelected = translateSizeToSlide(this.lastSize);
    this.carouselData();
    this.updateCellSize();
  }

  private updateCarousel(payload: { currentSlide: number}) {
    this.cellSlideSelected = payload.currentSlide;
    this.updateCellSize();
  }

  private updateCellSize() {
    const currentSize = translateSlideToSize(this.cellSlideSelected);
    this.$emit('cellSize:update', currentSize);
  }
}
